import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Linkedin, Mail, Phone } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useLanguage } from '../context/LanguageContext';

const TeamPage = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  const teamMembers = [
    {
      name: 'Dominique Dejonghe',
      role: 'AI for HR change and transformation agent',
      photo: '/dominique-photo.png',
      description: language === 'nl' 
        ? 'Expert in AI-strategie en HR-transformatie. Helpt organisaties om AI succesvol te implementeren in hun HR-processen.'
        : 'Expert in AI strategy and HR transformation. Helps organizations successfully implement AI in their HR processes.',
      email: 'dominique@humanistix.be',
      phone: '+32 498 900 947',
      linkedin: 'https://www.linkedin.com/in/dominiquedejonghe/'
    },
    {
      name: 'Luc Langeraert',
      role: 'Digital HR & Change',
      photo: '/luc-photo.png',
      description: language === 'nl' 
        ? 'Gespecialiseerd in digitale HR-transformatie en change management. Begeleidt teams door verandertrajecten.'
        : 'Specialized in digital HR transformation and change management. Guides teams through change processes.',
      email: 'luc@humanistix.be',
      phone: '+32 494 56 18 19',
      linkedin: 'https://www.linkedin.com/in/luclangeraert/'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Back Button */}
          <button
            onClick={() => navigate(-1)}
            className="flex items-center text-gray-600 hover:text-gray-900 mb-8 transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            {language === 'nl' ? 'Terug' : 'Back'}
          </button>

          {/* Hero */}
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              {language === 'nl' ? 'Ons Team' : 'Our Team'}
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              {language === 'nl' 
                ? 'Maak kennis met de experts achter Humanistix.'
                : 'Meet the experts behind Humanistix.'}
            </p>
          </div>

          {/* Team Members */}
          <div className="space-y-8">
            {teamMembers.map((member) => (
              <div key={member.name} className="bg-white rounded-2xl shadow-sm overflow-hidden">
                <div className="md:flex">
                  <div className="md:w-1/3">
                    <img 
                      src={member.photo} 
                      alt={member.name}
                      className="w-full h-64 md:h-full object-cover"
                    />
                  </div>
                  <div className="p-8 md:w-2/3">
                    <h2 className="text-2xl font-bold text-gray-900 mb-1">{member.name}</h2>
                    <p className="text-blue-500 font-medium mb-4">{member.role}</p>
                    <p className="text-gray-600 mb-6">{member.description}</p>
                    
                    <div className="space-y-2">
                      <a 
                        href={`mailto:${member.email}`}
                        className="flex items-center gap-2 text-sm text-gray-600 hover:text-blue-500 transition-colors"
                      >
                        <Mail className="h-4 w-4" />
                        {member.email}
                      </a>
                      <a 
                        href={`tel:${member.phone.replace(/\s/g, '')}`}
                        className="flex items-center gap-2 text-sm text-gray-600 hover:text-blue-500 transition-colors"
                      >
                        <Phone className="h-4 w-4" />
                        {member.phone}
                      </a>
                      <a 
                        href={member.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 text-sm text-gray-600 hover:text-blue-500 transition-colors"
                      >
                        <Linkedin className="h-4 w-4" />
                        LinkedIn
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default TeamPage;
